<div class="layerContainer">
  <appLayerItem
    v-for="(item, index) in items"
    :item="item"
    :index="index"
    :updateItem="updateItem"
    :defaultItemProps="defaultItemProps"
  ></appLayerItem>
</div>
